import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './../assets/context/AuthContext';
import url from './url';

function BusinessPasswordChange() {
    const { isLoggedIn, mustChangePassword, clearMustChangePassword, logout } = useAuth();
    const navigate = useNavigate();
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        // If the user is not logged in or doesn't need to change their password, redirect away
        if (!isLoggedIn) {
            navigate('/Login');
            return;
        }
        if (!mustChangePassword) {
            navigate('/Bookings');
        }
    }, [isLoggedIn, mustChangePassword, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (newPassword.length < 8) {
            setError('Password must be at least 8 characters');
            return;
        }
        if (newPassword !== confirmPassword) {
            setError('Passwords do not match');
            return;
        }

        setIsSubmitting(true);
        try {
            const response = await fetch(`${url}/api/business/change-initial-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
                },
                body: JSON.stringify({ newPassword }),
            });
            const data = await response.json();

            if (!response.ok) {
                setError(data.error || 'Unable to change password');
                return;
            }

            // Update the auth context with the fresh token
            clearMustChangePassword(data.token);
            navigate('/Bookings');
        } catch (err) {
            console.error('Password change error:', err);
            setError('An unexpected error occurred. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!isLoggedIn || !mustChangePassword) return null;

    return (
        <div className="login-wrapper center-center">
            <div className="login-container">
                <h2>Set your password</h2>
                <p style={{ marginBottom: '1.5rem', color: 'var(--text-muted, #666)', fontSize: '0.95rem' }}>
                    Welcome to your business account. Before you can continue, please set a new password.
                </p>
                <form
                    onSubmit={handleSubmit}
                    className="login-fields d-flex justify-content-center align-items-center flex-column"
                >
                    {error && <div className="alert alert-danger" role="alert">{error}</div>}
                    <input
                        type="password"
                        placeholder="New password (min. 8 characters)"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        minLength={8}
                        maxLength={128}
                        required
                        autoFocus
                    />
                    <input
                        type="password"
                        placeholder="Confirm new password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        minLength={8}
                        maxLength={128}
                        required
                    />
                    <div className="d-flex justify-content-between align-items-center mt-4 w-100">
                        <button type="submit" className="btn btn-smth" disabled={isSubmitting}>
                            {isSubmitting ? 'Saving…' : 'Set password & continue'}
                        </button>
                        <button
                            type="button"
                            style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-muted, #666)', fontSize: '0.9rem' }}
                            onClick={() => { logout(); navigate('/Login'); }}
                        >
                            Sign out
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default BusinessPasswordChange;
